var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light bg-light"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('svg', {
    staticClass: "d-inline-block align-top",
    attrs: {
      "width": "30",
      "height": "30"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#soulection"
    }
  })]), _vm._v("\n      Soulection Tracklists\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarNav"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'Episodes'
      }
    }
  }, [_vm._v("Episodes")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'Playlists'
      }
    }
  }, [_vm._v("Playlists")])], 1), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('router-view', {
    staticClass: "container"
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('svg', {
    attrs: {
      "width": "50",
      "height": "50",
      "fill": "#d9d9d9"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#soulection"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Soulection Tracklists is a product of ❤️ for the community and discovery of sounds.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarNav",
      "aria-controls": "navbarNav",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "https://kylewelsby.typeform.com/to/qZCg4b",
      "target": "_blank"
    }
  }, [_vm._v("Suggest Edit")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Developed and maintained by "), _c('a', {
    attrs: {
      "href": "https://mekyle.com"
    }
  }, [_vm._v("Kyle Welsby")]), _vm._v(" and is not affiliated with "), _c('a', {
    attrs: {
      "href": "https://soulection.com"
    }
  }, [_vm._v("Soulection LLC")]), _vm._v(". ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://ko-fi.com/A3403WZD"
    }
  }, [_vm._v("☕️ Buy Me a Coffee")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = iaho
// module chunks = 1